import { useFirebase } from '../../../contexts/FirebaseContext';
import { Footer } from '../../components/Footer/Footer';
import { ScrollableList } from '../../components/ScrollableList/ScrollableList';
import { Topbar } from '../../components/Topbar/Topbar';
import { Title } from '../../components/Title/Title';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useTranslation } from 'react-i18next';

const MyListComponent = () => {
  const { myList } = useFirebase();
  const { t } = useTranslation();

  return (
    <>
      <Title>{t('labels.mieiToot')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      {!myList && <FullscreenLoader fullscreen={false} />}

      {!!myList && (
        <>
          {!myList.length && (
            <div className={'my-5'}>
              <h1 className={'text-center display-4'}>{t('myList.labels.nonHaiAggiunto')}</h1>
              <p className={'text-center'}>{t('myList.labels.aggiungiQualcosa')}</p>
            </div>
          )}
          {!!myList.length && <ScrollableList title={t('labels.mieiToot')} elements={myList} />}
        </>
      )}

      <Footer />
    </>
  );
};

export default MyListComponent;
